<template>
  <el-dialog
      title="选择所属行业"
      width="40%"
      :visible.sync="compVisible"
      v-if="compVisible"
      class="abow_dialog"
  >
    <div class="cate_tree">
      <div v-show="selectName" style="padding-bottom:5px;">
        <!--   <span>{{this.selectName}}</span>
       -->
        <el-tag style="margin-right: 5px"
                v-for="(item,index) in selectName.split(',')"
                :key="index"
                type="info">
          {{ item }}
        </el-tag>
      </div>
      <el-input
          size="small"
          placeholder="请输入行业"
          prefix-icon="el-icon-search"
          v-model.trim="treeSearchParam">
        <el-button slot="append" class="input-icon" label="查询" style="color: #108cee" @click="handleIconClick">查询
        </el-button>
      </el-input>
      <div class="tree-only">
        <new-tree
            highlightCurrent
            ref="tree"
            class="flex"
            :data="data"
            node-key="id"
            :props="defaultProps"
            :expand-on-click-node="true"
            check-strictly
            show-checkbox
            @check-change="handleCheckChange"
            :filter-node-method="filterNode"
            :default-expanded-keys="defaultNode">
        </new-tree>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="compVisible = false">取 消</el-button>
        <el-button type="primary" @click="getIndustry">确 定</el-button>
      </span>
  </el-dialog>
</template>
<script>

import NewTree from '@/components/real-new-tree.vue';

export default {
  data() {
    return {
      treeSearchParam: "",
      data: [],
      defaultProps: {
        children: "childList",
        label: "cName",
      },
      defaultNode: [],
      clickNode: {},
      pId: 0,
      selectName: "",
      selectId: [],
      compVisible: false,
      selectIndustry: [],
    };
  },
  methods: {
    handleIconClick() {
      this.$refs.tree.returnRef().filter(this.treeSearchParam);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.cName.indexOf(value) !== -1;
    },
    open(obj) {
      this.compVisible = true
      this.treeSearchParam = "";
      this.selectName = "";
      this.defaultNode = [];
      this.getIndustryTrees().then(res => {
        this.data = res;
        this.selectIndustry = JSON.parse(JSON.stringify(obj.selectIndustry));
        this.industryParentIds = obj.industryParentIds && obj.industryParentIds.split(",") || [];
        this.$nextTick(() => {
          this.defaultNode = this.industryParentIds && [...this.industryParentIds] || [];
          setTimeout(() => {
            this.$refs.tree.returnRef().setCheckedKeys([...this.industryParentIds, ...this.selectIndustry.map(s => s.id)])
          })
          this.selectIndustry.forEach((item) => {
            this.selectName = this.selectName ? this.selectName + ',' + item.cName : item.cName;
          })
          this.noChildSelect = JSON.parse(JSON.stringify(obj.selectIndustry))
        })
      })
    },
    getIndustry() {
      if (!this.noChildSelect.length) {
        return this.$message.warning("请选择所属行业")
      }
      let pnodeId = []
      this.noChildSelect.forEach((n, index) => {
        let pnodes = this.$refs.tree.returnRef().getNodePath(n.id)
        pnodes.splice(pnodes.length - 1, 1)
        pnodeId.push(...pnodes)
      })
      pnodeId = this.removeArr(pnodeId)
      this.industryParentIds = pnodeId.map(p => p.id).join(",")
      let industryCode = "";
      let industryName = "";
      if (!pnodeId.length) {
        industryCode = this.noChildSelect[0].id
        industryName = this.noChildSelect[0].cName
      } else {
        industryCode = pnodeId[0].id;
        industryName = pnodeId[0].cName;
      }
      this.$emit('getIndustry', {
        selectIndustry: this.noChildSelect,
        industryParentIds: this.industryParentIds,
        industryCode: industryCode,
        industryName: industryName
      })
      this.compVisible = false;
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        let has = this.selectIndustry.some(s => s.id === data.id)
        !has && this.selectIndustry.push(data);
        if (data.pId != 0) {
          //获取所有父级
          let parents = this.$refs.tree.returnRef().getNodePath(data.id)
          let pars = parents.splice(0, parents.length - 1)
          this.$nextTick(() => {
            pars.forEach(n => {
              this.$refs.tree.returnRef().getNode(n.id).checked = true
            })
          })
        }
        this.setValue();
      } else {
        let ind = this.selectIndustry.findIndex(s => s.id === data.id)
        if (ind > -1) {
          this.selectIndustry.splice(ind, 1);
        }
        this.setNoCheckValue(data.id);
      }
      // this.$emit("selectIndustrys", this.selectIndustry);
    },
    setNoCheckValue(id) {
      this.getChilds(id).then(res => {
        this.setValue()
      })
    },
    //取消所有子集的选中
    getChilds(id) {
      let cnode = this.$refs.tree.returnRef().getNode(id).childNodes
      if (cnode) {
        cnode.forEach(c => {
          c.checked = false
          this.getChilds(c.data.id)
        })
      }
      return new Promise(resolve => {
        resolve(1)
      })
    },
    //选中的
    setValue() {
      this.$nextTick(() => {
        //获取所有没有子节点选中的节点
        let selectin = this.$refs.tree.returnRef().getCheckedNodes();
        this.noChildSelect = selectin.filter(c => {
          let node = this.$refs.tree.returnRef().getNode(c.id)
          let has = node && node.childNodes.some(n => n.checked)
          return !has && c
        })
        this.selectName = '';
        this.noChildSelect.forEach((item) => {
          this.selectName = this.selectName ? this.selectName + ',' + item.cName : item.cName;
        })
      })
    },
    getZtree() {
      return this.$refs.tree.returnRef();
    },
    //对象数组去重
    removeArr(arr) {
      const res = new Map();
      return arr.filter((a) => !res.has(a.id) && res.set(a.id, 1))
    },
    getCateZtree(node, resolve, arg) {
      if (node.level === 0) {
        this.getTree().then(res => {
          this.data = res;
          this.$nextTick(() => {
            // this.$refs.tree.returnRef().setCheckedKeys([...this.selectIndustry.map(s => s.id)])
          })
          resolve(this.data);
        })
      }
      if (node.level > 0) {
        this.pId = node.data.id;
        this.getTreeByPid().then(res => {
          this.$nextTick(() => {
            /*this.selectIndustry.forEach((s) => {
              this.$refs.tree.returnRef().setChecked(s.id, true);
            })*/
            // this.$refs.tree.returnRef().setCheckedKeys([...this.selectIndustry.map(s => s.id)])
          })
          resolve(res);
        })
      }
    },
    /*handleIconClick(ev) {
      let url = `/Yunos/CompIndustryCategory/MdIndustryDataByName?Name=${this.treeSearchParam}`;
      this.$axios.get(url).then(res => {
        this.data = res;
      })
    },*/
    getIndustryTrees() {
      let url = `/Crm/CompIndustryCategory/AllMdIndustryCategoryList`
      return this.$axios.get(url)
    },
    getTree() {
      let url = `/Crm/CompIndustryCategory/MdIndustryCategory?pid=0`;
      return this.$axios.get(url);
    },
    getTreeByPid() {
      let url = `/Crm/CompIndustryCategory/MdIndustryCategory?pid=${this.pId}`;
      return this.$axios.get(url);
    },
    handleClose(done) {
      this.cateVisible = false
    }
  },
  watch: {
    cateVisible(val) {
      if (!val) {
        this.thisId = 0;
      }
    },
  },
  components: {NewTree}
};
</script>
<style scoped lang="scss">
.cate_tree {
  font-size: 13px;
  line-height: 2;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;

  .input-icon {
    cursor: pointer;
  }

  .tree-only {
    border: 1px solid #D7D7D7;
    padding: 0 5px;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    max-height: 450px;
    border-radius: 12px;

    .tree-container {
      overflow: auto;
      padding-top: 10px;
      border-radius: 12px;
    }

    .tree-title {
      padding: 5px 12px;
      font-size: 16px;
      display: flex;
    }

    .el-tree {
      overflow: auto;
      height: 300px;
    }
  }

  .tree_content {
    display: flex;
    flex: 1;

    span:first-child {
      flex: 1;
    }

    .tree_operate {
      display: none;
    }

    &:hover {
      .tree_operate {
        display: inline;
      }
    }
  }
}
</style>
